"use strict";

module.exports = [];


//////////////////
// WEBPACK FOOTER
// ./~/@sanity/client/lib/http/browserMiddleware.js
// module id = 266
// module chunks = 0